import FiservQrSubsidiarySaleStandForm from 'forms/FiservQrSubsidiarySaleStandForm';

export default (): JSX.Element => <FiservQrSubsidiarySaleStandForm />;
